import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import ElementPlus from 'element-plus'
import * as ElementPlusIconsVue  from '@element-plus/icons-vue'
import 'element-plus/dist/index.css'
import zhCn from 'element-plus/es/locale/lang/zh-cn'

const app = createApp(App);
// 注册所有图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}

const lanType = window.localStorage.getItem('lanType');
if(!lanType || lanType=="CN"){ //中文
    app.use(router).use(ElementPlus,{locale:zhCn}).mount('#app')
}else{
    app.use(router).use(ElementPlus).mount('#app')
}

